import { render, staticRenderFns } from "./RecurringPaymentList.vue?vue&type=template&id=2ecc5a10&scoped=true"
import script from "./RecurringPaymentList.vue?vue&type=script&lang=js"
export * from "./RecurringPaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc5a10",
  null
  
)

export default component.exports